let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bHJC3")).then(() => parcelRequire('hM5to'));